import {
  DRIVER_SEARCH_COLUMNS,
  type DriverSearchTarget,
  isSamsaraUsernameTag,
  SAMSARA_USERNAME_TAG_LABEL,
  type TagDefinition,
} from "@/types/driver";

/** Default platform tag labels included in driver-view search (exact match on current local `tag.label`). */
//examples: ["Branch location", "Driver classification", "Driver branch"],
const DRIVER_VIEW_SEARCHABLE_TAG_LABELS = ["Branch location", "Vehicle"] as const;

const CORE_DRIVER_SEARCH_TARGETS: readonly DriverSearchTarget[] = DRIVER_SEARCH_COLUMNS.map((field) => ({
  kind: "column" as const,
  field,
}));

/**
 * Returns driver-view search targets: all core roster columns plus tag targets for allowlisted tag labels.
 */
export function buildDriverViewSearchTargets(tags: readonly TagDefinition[]): readonly DriverSearchTarget[] {
  const labelSet = new Set<string>(DRIVER_VIEW_SEARCHABLE_TAG_LABELS);
  const tagTargets: DriverSearchTarget[] = [];
  for (const t of tags) {
    const legacySamsaraUsernameTag = isSamsaraUsernameTag(t) && t.label !== SAMSARA_USERNAME_TAG_LABEL;
    if (labelSet.has(t.label) || legacySamsaraUsernameTag) {
      tagTargets.push({ kind: "tag", tagId: t.id });
    }
  }
  return [...CORE_DRIVER_SEARCH_TARGETS, ...tagTargets];
}
